// extracted by mini-css-extract-plugin
export default {"p_tye":"b9c62c53b2","slcted":"abe6013b79","slc_color":"_3555667654","item_p":"_9837626b35","r0":"_48188df33c"};